import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";

const initialState = {
    groupGuid:"",
    timeoutRemaining:0,
    statusSwitch:'idle',
    status:"idle",
    isTimedOut: false,
}
/**
 * 
 * const { user: currentUser } = useSelector((state) => state.auth);
 */
const WELLSUITE = '../../WsWebServiceWellSuite/'
const PLATFORM = '../../WsWebServicePlatform/'
const HRA = '../../WsWebServiceHra/'
const WEBAPP = '../../WsWebAppWellSuite';



export const userKeepAlive = createAsyncThunk('auth/keepalive', async (incomingVariable, thunkAPI) => {
    const state = thunkAPI.getState()

    const { mainUser, behalfOfUser } = state.auth
    //
    // when logout is called, log out of behalf of if availble
    //
    const isBehalfOf = behalfOfUser && behalfOfUser.AuthToken ? true : false
    const AuthTokenToUse = isBehalfOf && state.auth.statusSwitch==='success' && state.auth.status !=='loading' ? behalfOfUser.AuthToken || mainUser.AuthToken : mainUser.AuthToken
    const AuthTokenToUse_Second = isBehalfOf ? mainUser.AuthToken : null

    try {
        
        const response = await axios.post(PLATFORM + "Participant/Session/KeepAlive/" + AuthTokenToUse + "/");
        const data = await response.data

        if (AuthTokenToUse_Second) {
            const response2 = await axios.post(PLATFORM + "Participant/Session/KeepAlive/" + AuthTokenToUse_Second + "/");
            const data2 = await response2.data
        }

        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const userTimeoutSecondsRemaining = createAsyncThunk('auth/timeout', async (incomingVariable, thunkAPI) => {
    const state = thunkAPI.getState()
    const { mainUser } = state.auth
    //
    // when logout is called, log out of behalf of if availble
    //
    const AuthTokenToUse = mainUser.AuthToken


    try {

        const response = await axios.get(PLATFORM + "Participant/Session/TimeoutSecondsRemaining/" + AuthTokenToUse + "/");
        const data = await response.data


        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const timeoutSlice = createSlice({
    name: 'timeouts',
    initialState,
    reducers: {
        timeoutClear(state, action) {
            
            state.groupGuid=""
            state.timeoutRemaining=0
            state.statusSwitch='idle'
            state.isTimedOut= false
            
        },
    },
    extraReducers(builder) {
        builder
            //
            
            

            //////////////////
            //////////////////
            //////////////////

            .addCase(userKeepAlive.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(userKeepAlive.fulfilled, (state, action) => {

                const Success = action.payload.Success
                if (Success === true) {
                    state.status = 'success'
                } 

            })
            .addCase(userKeepAlive.rejected, (state, action) => {
                state.error = action.error.message
                state.status='failed'
                console.log('failed')
            })
            //////////////////
            //////////////////
            //////////////////

            .addCase(userTimeoutSecondsRemaining.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(userTimeoutSecondsRemaining.fulfilled, (state, action) => {

                const Success = action.payload.Success
                if (Success === true) {
                    state.timeoutRemaining = action.payload.Info[0].TimeoutSecondsRemaining
                    state.isTimedOut = false
                    state.status = 'success'
                } 
                
                if (Success===false || action.payload.Info[0].TimeoutSecondsRemaining <=0) {
                    
                    state.isTimedOut = true
                    console.log('timeout')

                }

            })
            .addCase(userTimeoutSecondsRemaining.rejected, (state, action) => {
                state.error = action.error.message
                state.isTimedOut = true
                state.status='failed'
                console.log('failed')
            })

    }
})

export const { timeoutClear } = timeoutSlice.actions

export default timeoutSlice.reducer

const selectTimeoutEntities = (state) => state.timeouts.entities

export const selecttimeouts = createSelector(selectTimeoutEntities, (entities) =>
    Object.values(entities)
)



